import { render, staticRenderFns } from "./Impact.vue?vue&type=template&id=fa599fb0"
import script from "./Impact.vue?vue&type=script&lang=js"
export * from "./Impact.vue?vue&type=script&lang=js"
import style0 from "./Impact.vue?vue&type=style&index=0&id=fa599fb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports